import React from "react";
import { PawIcon, LockIcon } from "./Icons";

const ExternalQrNotice = ({ scanData, onClose, onOpenAdminLogin, user, onOpenInAdmin }) => {
  const isStaffOrAdmin = user && (user.role === "admin" || user.role === "staff");

  const handleDismiss = () => {
    // Clear URL path back to root without reloading
    window.history.replaceState(null, "", "/");
    onClose();
  };

  const handleStaffLogin = () => {
    onOpenAdminLogin();
  };

  const isPetQr = scanData?.type === "pet";

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/70 backdrop-blur-md animate-in fade-in duration-300">
      <div className="bg-white/95 backdrop-blur-2xl rounded-[2.5rem] shadow-2xl border border-purple-100 max-w-lg w-full p-8 md:p-10 relative text-center overflow-hidden animate-in zoom-in-95 duration-300">
        
        {/* Decorative background gradients */}
        <div className="absolute -top-20 -left-20 w-48 h-48 bg-purple-400/20 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute -bottom-20 -right-20 w-48 h-48 bg-pink-400/20 rounded-full blur-3xl pointer-events-none" />

        {/* Top Icon Badge */}
        <div className="relative mx-auto w-24 h-24 mb-6 flex items-center justify-center">
          <div className="absolute inset-0 bg-gradient-to-tr from-purple-600 via-fuchsia-500 to-pink-500 rounded-3xl rotate-6 shadow-xl shadow-purple-500/30 animate-pulse" />
          <div className="relative w-full h-full bg-slate-900 rounded-3xl flex items-center justify-center border-2 border-white/20">
            <span className="text-4xl">📱</span>
          </div>
          <div className="absolute -bottom-2 -right-2 bg-emerald-500 text-white p-1.5 rounded-full shadow-lg border-2 border-white">
            <LockIcon size={14} color="white" />
          </div>
        </div>

        {/* Badge */}
        <div className="inline-flex items-center gap-1.5 px-3.5 py-1 rounded-full bg-purple-100/80 border border-purple-200 text-purple-700 text-xs font-bold uppercase tracking-wider mb-3">
          <PawIcon size={12} color="#7E22CE" />
          <span>{isPetQr ? "Pet Digital Pass" : "Check-In Pass"}</span>
        </div>

        {/* Title & Subtitle */}
        <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-3 tracking-tight">
          Staff / Admin Scanner Required
        </h2>

        <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-6 font-medium">
          This QR code is an official clinic verification pass for <strong className="text-purple-700">Furpect Tails</strong>. It must be scanned using the built-in scanner inside the <strong className="text-gray-800">Staff / Admin Portal</strong> at our clinic.
        </p>

        {/* Information box */}
        <div className="bg-purple-50/70 border border-purple-100 rounded-2xl p-4 text-left mb-6 space-y-2">
          <div className="flex items-start gap-2.5">
            <span className="text-base shrink-0 mt-0.5">ℹ️</span>
            <div className="text-xs text-purple-900/90 leading-relaxed font-medium">
              <strong>Why am I seeing this?</strong> You scanned this code with a standard mobile camera or external scanner. For privacy and security, pet medical records and check-in confirmation are managed directly through our staff terminal.
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          {isStaffOrAdmin ? (
            <button
              onClick={() => {
                handleDismiss();
                if (onOpenInAdmin) onOpenInAdmin(scanData);
              }}
              className="w-full py-4 px-6 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-bold text-base rounded-2xl shadow-xl shadow-purple-500/30 hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
            >
              <span>🛡️</span> Open in Admin Dashboard
            </button>
          ) : (
            <button
              onClick={handleStaffLogin}
              className="w-full py-4 px-6 bg-gradient-to-r from-purple-600 via-fuchsia-600 to-pink-600 text-white font-bold text-base rounded-2xl shadow-xl shadow-purple-500/30 hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
            >
              <span>🛡️</span> Staff / Admin Sign In
            </button>
          )}

          <button
            onClick={handleDismiss}
            className="w-full py-3.5 px-6 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold text-sm rounded-2xl transition-all"
          >
            Go to Furpect Tails Homepage 🐾
          </button>
        </div>

      </div>
    </div>
  );
};

export default ExternalQrNotice;
